import { render, staticRenderFns } from "./privateForm.vue?vue&type=template&id=1adb7fe4&scoped=true"
import script from "./privateForm.vue?vue&type=script&lang=js"
export * from "./privateForm.vue?vue&type=script&lang=js"
import style0 from "./privateForm.vue?vue&type=style&index=0&id=1adb7fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb7fe4",
  null
  
)

export default component.exports